// extracted by mini-css-extract-plugin
export default {"card":"ServiceCard_card__rYzMO","card-title":"ServiceCard_card-title__FHDYB","card-content":"ServiceCard_card-content__bYEFd"};